'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _navIndexContainer = require('./navbar/navIndexContainer');

var _navIndexContainer2 = _interopRequireDefault(_navIndexContainer);

var _footerIndexContainer = require('./footer/footerIndexContainer');

var _footerIndexContainer2 = _interopRequireDefault(_footerIndexContainer);

var _converter = require('./utils/converter');

var _converter2 = _interopRequireDefault(_converter);

var _i18n = require('./utils/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeaderFooterWrapper(props) {
    var isDev = props.isDev,
        currentLang = props.currentLang,
        isLogin = props.isLogin,
        handleLoginPress = props.handleLoginPress,
        handleChangeLang = props.handleChangeLang,
        onURLClick = props.onURLClick,
        aioURL = props.aioURL,
        hoverSectionAndPath = props.hoverSectionAndPath,
        headerChild = props.headerChild,
        disableHeader = props.disableHeader,
        disableFooter = props.disableFooter,
        disableLogin = props.disableLogin,
        isHeaderFixedTop = props.isHeaderFixedTop;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        headerComplete = _useState2[0],
        setHeaderComplete = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        footerComplete = _useState4[0],
        setFooterComplete = _useState4[1];

    (0, _react.useEffect)(function () {
        var cmsURL = isDev ? "https://aioapps-qa.hkbn.net/cmsdata/" : "https://aio-static.hkbn.net/";

        _axios2.default.get(cmsURL + 'headerFooter-json-mapping.json').then(function (res) {
            if (!disableHeader) {
                _axios2.default.get(res.data.queryHeaderContents.StaticJsonFile.CDNUrl).then(function (headerRes) {
                    var convertedHeader = _converter2.default.header(headerRes.data);
                    var searchParams = new URLSearchParams(window.location.search);
                    if (searchParams.has('hdnav')) {
                        var hiddenList = searchParams.get('hdnav').toLowerCase().split('|');
                        // hide navitem by removing pages
                        convertedHeader = {
                            cn: Object.assign({}, convertedHeader.cn, { pages: convertedHeader.cn.pages ? convertedHeader.cn.pages.filter(function (item) {
                                    return !item.key || !hiddenList.includes(item.key.toLowerCase());
                                }) : [] }),
                            en: Object.assign({}, convertedHeader.en, { pages: convertedHeader.en.pages ? convertedHeader.en.pages.filter(function (item) {
                                    return !item.key || !hiddenList.includes(item.key.toLowerCase());
                                }) : [] })
                        };
                    }
                    _i18n2.default.addResourceBundle('en-US', 'header', convertedHeader.en);
                    _i18n2.default.addResourceBundle('zh-HK', 'header', convertedHeader.cn);
                    setHeaderComplete(true);
                });
            }
            if (!disableFooter) {
                _axios2.default.get(res.data.queryFooterContents.StaticJsonFile.CDNUrl).then(function (footerRes) {
                    var convertedFooter = _converter2.default.footer(footerRes.data);
                    _i18n2.default.addResourceBundle('en-US', 'footer', convertedFooter.en);
                    _i18n2.default.addResourceBundle('zh-HK', 'footer', convertedFooter.cn);
                    setFooterComplete(true);
                });
            }
        }).catch(function (err) {
            console.log(err);
        });
    }, []);

    return _react2.default.createElement(
        _react.Fragment,
        null,
        !disableHeader && _react2.default.createElement(_navIndexContainer2.default, {
            isDev: isDev,
            currentLang: currentLang,
            isLogin: isLogin,
            handleLoginPress: handleLoginPress,
            handleChangeLang: handleChangeLang,
            onURLClick: onURLClick,
            aioURL: aioURL,
            hoverSectionAndPath: hoverSectionAndPath,
            headerChild: headerChild,
            loadingComplete: headerComplete,
            disableLogin: disableLogin,
            isHeaderFixedTop: isHeaderFixedTop
        }),
        props.children,
        !disableFooter && _react2.default.createElement(_footerIndexContainer2.default, {
            currentLang: currentLang,
            isDev: isDev,
            aioURL: aioURL,
            onURLClick: onURLClick,
            loadingComplete: footerComplete
        })
    );
}

exports.default = HeaderFooterWrapper;